<template>
    <div class="info-popover-container cursor-pointer text-white">
        <i class="fa fa-info-circle"
           :id="popoverId"
           @mouseover="showPopover"
           @mouseleave="hidePopover"
        />

        <b-popover :target="popoverId"
                   triggers=""
                   :show.sync="popoverShow"
                   placement="right"
        >
            <template #title>
                <slot name="title">Información Importante</slot>
            </template>
            <slot>
                <p>Si sabe que el producto no es peligroso y es relevante considerar su porcentaje, seleccione esta
                    casilla.</p>
                <p><strong>Ejemplo:</strong> El agua no es peligrosa, pero su selección es necesaria para efectos del
                    porcentaje.</p>
            </slot>
        </b-popover>
    </div>
</template>

<script>
let uniqueId = 0;

export default {
    name: 'InfoPopover',
    data() {
        return {
            popoverShow: false,
            popoverId: `popover-${uniqueId++}`
        };
    },
    methods: {
        showPopover() {
            this.popoverShow = true;
        },
        hidePopover() {
            this.popoverShow = false;
        }
    }
};
</script>
